// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.stack-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-right: 8px; /* o 1rem */
}

.stack-section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0;
  /* ← Elimina margen inferior que empuja el título hacia abajo */
}

.stack-section-title mat-icon {
  margin-right: 8px;
}

.header-button-icon {
  margin: auto;
  padding: 0px;
  font-size: 22px !important;
}

.stack-section-title mat-icon {
  color: #3f51b5;
  /* azul Material */
}

.icon-blue {
  color: var(--ion-color-offline);
}

.table-responsive mat-icon {
  font-size: 22px !important;
}

.title-label {
  font-weight: 600;
}

.table-responsive {
  overflow-x: auto;
  margin-bottom: 2rem;
}

table.mat-table {
  width: 100%;
  border-collapse: collapse;
}

.mat-header-cell,
.mat-cell {
  padding: 8px 16px;
  font-size: 14px;
  white-space: nowrap;
}

.mat-header-cell {
  font-weight: 600;
  background-color: #f5f5f5;
}

.mat-row:nth-child(even) {
  background-color: #fafafa;
}

.mat-elevation-z2 {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  overflow: hidden;
}

/* Colorear celdas de error si error > 0 */
td.error-value {
  color: #e25454;
  font-weight: 600;
}

td.error-value::before {
  content: "⚠ ";
  font-weight: bold;
}

/* Columna de tipo con badge */
.type-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}

.type-badge.BLUETOOTH {
  background-color: #e3f2fd;
  color: #1976d2;
}

.type-badge.nbiot {
  background-color: #e8f5e9;
  color: #388e3c;
}

/* Responsive font sizes */
@media (max-width: 768px) {
  .mat-header-cell,
  .mat-cell {
    font-size: 12px;
    padding: 6px 10px;
  }
  .form-section-title {
    font-size: 1rem;
  }
}
.nodo-summary-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: flex-start;
}

.nodo-card {
  position: relative;
  flex: 1 1 220px;
  max-width: 230px;
  background: #fefefe;
  border-radius: 10px;
  padding: 14px 14px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
}
.nodo-card .sensor-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.nodo-card .sensor-info .fecha {
  font-size: 14px;
  color: #000000;
  white-space: nowrap;
  /* evita que se corte la fecha */
}
.nodo-card .node-label {
  color: #1565c0;
  font-size: 17px;
  font-weight: 700;
  text-transform: uppercase;
  font-family: "Montserrat", sans-serif;
  border-radius: 8px;
  display: inline-block;
}
.nodo-card .sensor-details {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  line-height: 1.6;
}
.nodo-card .sensor-details span {
  display: block;
  margin-bottom: 4px;
}
.nodo-card .sensor-details strong {
  color: #000;
  font-weight: 600;
}
.nodo-card .nodo-info-list {
  list-style: none;
  padding: 0;
  margin-top: 15px;
}
.nodo-card .nodo-info-list li {
  font-size: 13.5px;
  margin-bottom: 6px;
  color: #444;
}
.nodo-card .nodo-info-list li strong {
  color: #000;
  font-weight: 600;
}

.info-note {
  position: absolute; /* ← Cambio clave */
  background-color: #fff8e1;
  border-left: 4px solid #ffc107;
  padding: 12px 16px;
  font-size: 14px;
  color: #5f5f5f;
  margin-bottom: 20px;
  border-radius: 4px;
}
.info-note mat-icon {
  vertical-align: middle;
  margin-right: 8px;
  color: #ffc107;
}
.info-note strong {
  color: #333;
  font-weight: 600;
}

/* CSS CONSOLIDADO Y CORREGIDO PARA LA NOTA DE ADVERTENCIA */
.info-note.warning {
  /* Estilos generales del contenedor de la nota */
  background-color: #fffbe6; /* Fondo amarillo claro */
  border-left: 5px solid #ffc107; /* Borde amarillo a la izquierda */
  padding: 15px 20px; /* Relleno interno */
  margin-top: 20px; /* Margen superior */
  color: #616161; /* Color de texto oscuro */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Sombra sutil */
  border-radius: 4px; /* Bordes redondeados */
  font-size: 0.95em; /* Tamaño de fuente ligeramente más pequeño */
  /* ----- ¡ESTO ES CRUCIAL PARA LA VISIBILIDAD DE LA X! ----- */
  display: grid; /* Usa Grid para controlar el diseño de sus hijos (icono, contenido, botón) */
  grid-template-columns: auto 1fr auto; /* Define 3 columnas: Icono (auto), Contenido (1fr), Botón de cierre (auto) */
  grid-column-gap: 10px; /* Espacio entre las columnas de la cuadrícula */
  align-items: start; /* Alinea los elementos al inicio (parte superior) de sus celdas */
  position: relative; /* ¡MUY IMPORTANTE! Este es el contexto para 'position: absolute' del botón de cierre */
  /* -------------------------------------------------------- */
}

/* Estilos para el icono de advertencia (el triángulo) */
.info-note.warning .warning-icon {
  font-size: 24px; /* Tamaño del icono */
  width: 24px;
  height: 24px;
  line-height: 24px;
  margin-top: -2px; /* Ajuste fino para alineación vertical */
  grid-column: 1; /* Posiciona el icono en la primera columna de la cuadrícula */
  grid-row: 1/span 2; /* Hace que el icono abarque las filas del texto introductorio y la lista */
  align-self: flex-start; /* Alinea a la parte superior de su celda */
}

/* Estilos para el contenedor del contenido del mensaje (texto intro + lista) */
.info-note.warning .message-content {
  grid-column: 2; /* Posiciona el contenido en la segunda columna de la cuadrícula */
  grid-row: 1/span 2; /* Hace que el contenido abarque las filas del texto introductorio y la lista */
}

/* Estilo para el texto introductorio ("Se ha detectado...") */
.info-note.warning .message-content > ng-container {
  display: block; /* Asegura que el texto tome su propia línea */
  margin-bottom: 5px; /* Espacio entre el texto introductorio y la lista de errores */
}

/* Estilo para la lista de errores */
.info-note.warning .error-list {
  list-style: disc; /* Puntos de viñeta estándar */
  padding-left: 20px; /* Sangría para las viñetas */
  margin-top: 5px; /* Margen superior de la lista */
  margin-bottom: 0;
}

/* Estilo para cada elemento de la lista */
.info-note.warning .error-list li {
  margin-bottom: 8px; /* Espacio entre elementos de la lista */
  line-height: 1.4; /* Espaciado entre líneas del texto */
}

/* Estilo para la parte "Node X:" del mensaje */
.info-note.warning .error-list li .node-label {
  font-weight: bold; /* Negrita */
  white-space: nowrap; /* Evita que "Node X:" se parta en varias líneas */
}

/* ----- ¡ESTOS SON LOS ESTILOS PARA EL BOTÓN DE CIERRE (LA CRUZ)! ----- */
.info-note.warning .close-button {
  position: absolute; /* Posicionamiento absoluto, relativo a .info-note.warning */
  top: 5px; /* Distancia desde el borde superior */
  right: 5px; /* Distancia desde el borde derecho */
  color: #757575; /* Color del icono de la cruz */
  background: none; /* Sin fondo */
  border: none; /* Sin borde */
  cursor: pointer; /* Cursor de puntero al pasar por encima */
  padding: 5px; /* Área de clic alrededor del icono */
  transition: color 0.2s ease-in-out; /* Transición suave para el efecto hover */
  z-index: 10; /* Asegura que esté por encima de otros elementos si hay superposiciones */
  /* Nota: Si el botón de cierre va con 'position: absolute', no necesita 'grid-column' ni 'grid-row' */
}

.info-note.warning .close-button:hover {
  color: #424242; /* Color más oscuro al pasar el ratón */
}

/* ------------------------------------------------------------------ */
/* REVISIÓN: Asegúrate de que tu bloque '.info-note' GENERAL (si lo tienes)
   NO contenga 'display' ni 'position' si usas '.info-note.warning' para controlarlos.
   Si lo tiene, el bloque '.info-note.warning' debe ir después y ser más específico.
   Idealmente, si este es el único tipo de 'info-note', elimina el bloque '.info-note' general
   y solo usa '.info-note.warning'.
*/`, "",{"version":3,"sources":["webpack://./src/app/shared/components/info-stack/info-stack.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACE,kBAAA,EAAA,WAAA;AAEJ;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,+DAAA;AACF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EAIE,YAAA;EACE,YAAA;EACF,0BAAA;AAHF;;AAOA;EACE,cAAA;EACA,kBAAA;AAJF;;AAMA;EACE,+BAAA;AAHF;;AAKA;EACE,0BAAA;AAFF;;AAMA;EACE,gBAAA;AAHF;;AAQA;EACE,gBAAA;EACA,mBAAA;AALF;;AAQA;EACE,WAAA;EACA,yBAAA;AALF;;AAQA;;EAEE,iBAAA;EACA,eAAA;EACA,mBAAA;AALF;;AAQA;EACE,gBAAA;EACA,yBAAA;AALF;;AAQA;EACE,yBAAA;AALF;;AAQA;EACE,2CAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA,0CAAA;AACA;EACE,cAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,iBAAA;AALF;;AAQA,8BAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AALF;;AAQA;EACE,yBAAA;EACA,cAAA;AALF;;AAQA;EACE,yBAAA;EACA,cAAA;AALF;;AAQA,0BAAA;AACA;EAEE;;IAEE,eAAA;IACA,iBAAA;EANF;EASA;IACE,eAAA;EAPF;AACF;AAWA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;AATF;;AAYA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yCAAA;EACA,qDAAA;EACA,gBAAA;AATF;AAWE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AATJ;AAYE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gCAAA;AAVJ;AAcE;EAEE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qCAAA;EACA,kBAAA;EACA,qBAAA;AAbJ;AAgBE;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,cAAA;EACA,kBAAA;AAfJ;AAkBE;EACE,WAAA;EACA,gBAAA;AAhBJ;AAmBE;EACE,gBAAA;EACA,UAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;AAlBJ;AAqBE;EACE,WAAA;EACA,gBAAA;AAnBJ;;AA4BA;EACC,kBAAA,EAAA,mBAAA;EACC,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAzBF;AA2BE;EACE,sBAAA;EACA,iBAAA;EACA,cAAA;AAzBJ;AA4BE;EACE,WAAA;EACA,gBAAA;AA1BJ;;AA6BA,4DAAA;AAEA;EACE,gDAAA;EACA,yBAAA,EAAA,yBAAA;EACA,8BAAA,EAAA,kCAAA;EACA,kBAAA,EAAA,oBAAA;EACA,gBAAA,EAAA,oBAAA;EACA,cAAA,EAAA,0BAAA;EACA,wCAAA,EAAA,iBAAA;EACA,kBAAA,EAAA,uBAAA;EACA,iBAAA,EAAA,6CAAA;EAEA,8DAAA;EACA,aAAA,EAAA,6EAAA;EACA,oCAAA,EAAA,6EAAA;EACA,qBAAA,EAAA,gDAAA;EACA,kBAAA,EAAA,kEAAA;EACA,kBAAA,EAAA,uFAAA;EACA,6DAAA;AA5BF;;AA+BA,wDAAA;AACA;EAEE,eAAA,EAAA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA,EAAA,yCAAA;EACA,cAAA,EAAA,8DAAA;EACA,kBAAA,EAAA,2EAAA;EACA,sBAAA,EAAA,2CAAA;AA7BF;;AAgCA,+EAAA;AACA;EACE,cAAA,EAAA,kEAAA;EACA,kBAAA,EAAA,+EAAA;AA7BF;;AAgCA,8DAAA;AACA;EACI,cAAA,EAAA,8CAAA;EACA,kBAAA,EAAA,+DAAA;AA7BJ;;AAgCA,oCAAA;AACA;EACE,gBAAA,EAAA,8BAAA;EACA,kBAAA,EAAA,6BAAA;EACA,eAAA,EAAA,gCAAA;EACA,gBAAA;AA7BF;;AAgCA,0CAAA;AACA;EACE,kBAAA,EAAA,wCAAA;EACA,gBAAA,EAAA,qCAAA;AA7BF;;AAgCA,+CAAA;AACA;EACE,iBAAA,EAAA,YAAA;EACA,mBAAA,EAAA,kDAAA;AA7BF;;AAgCA,0EAAA;AACA;EACE,kBAAA,EAAA,4DAAA;EACA,QAAA,EAAA,sCAAA;EACA,UAAA,EAAA,qCAAA;EACA,cAAA,EAAA,+BAAA;EACA,gBAAA,EAAA,cAAA;EACA,YAAA,EAAA,cAAA;EACA,eAAA,EAAA,0CAAA;EACA,YAAA,EAAA,qCAAA;EACA,kCAAA,EAAA,0CAAA;EACA,WAAA,EAAA,0EAAA;EACA,qGAAA;AA7BF;;AAgCA;EACE,cAAA,EAAA,uCAAA;AA7BF;;AA+BA,uEAAA;AAEA;;;;;CAAA","sourcesContent":[".stack-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n    padding-right: 8px; /* o 1rem */\n\n}\n\n.stack-section-title {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.2rem;\n  font-weight: 500;\n  margin: 0;\n  /* ← Elimina margen inferior que empuja el título hacia abajo */\n\n}\n\n.stack-section-title mat-icon {\n  margin-right: 8px;\n}\n\n.header-button-icon {\n  // min-width: 36px;\n  // padding: 4px 6px;\n  // height: 36px;\n  margin: auto;\n    padding: 0px;\n  font-size: 22px! important;\n}\n\n\n.stack-section-title mat-icon {\n  color: #3f51b5;\n  /* azul Material */\n}\n.icon-blue {\n  color: var(--ion-color-offline)\n}\n.table-responsive mat-icon {\n  font-size: 22px! important;\n\n  \n}\n.title-label {\n  font-weight: 600;\n}\n\n\n\n.table-responsive {\n  overflow-x: auto;\n  margin-bottom: 2rem;\n}\n\ntable.mat-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.mat-header-cell,\n.mat-cell {\n  padding: 8px 16px;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n.mat-header-cell {\n  font-weight: 600;\n  background-color: #f5f5f5;\n}\n\n.mat-row:nth-child(even) {\n  background-color: #fafafa;\n}\n\n.mat-elevation-z2 {\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n/* Colorear celdas de error si error > 0 */\ntd.error-value {\n  color: #e25454;\n  font-weight: 600;\n}\n\ntd.error-value::before {\n  content: '⚠ ';\n  font-weight: bold;\n}\n\n/* Columna de tipo con badge */\n.type-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.type-badge.BLUETOOTH {\n  background-color: #e3f2fd;\n  color: #1976d2;\n}\n\n.type-badge.nbiot {\n  background-color: #e8f5e9;\n  color: #388e3c;\n}\n\n/* Responsive font sizes */\n@media (max-width: 768px) {\n\n  .mat-header-cell,\n  .mat-cell {\n    font-size: 12px;\n    padding: 6px 10px;\n  }\n\n  .form-section-title {\n    font-size: 1rem;\n  }\n}\n\n//TARJETAS DEL INFORMACION DE MEDIDA.nodo-summary-grid {\n.nodo-summary-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  justify-content: flex-start;\n}\n\n.nodo-card {\n  position: relative;\n  flex: 1 1 220px;\n  max-width: 230px;\n  background: #fefefe;\n  border-radius: 10px;\n  padding: 14px 14px;\n  border: 1px solid #e0e0e0;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  overflow: hidden;\n\n  .sensor-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n  }\n\n  .sensor-info .fecha {\n    font-size: 14px;\n    color: #000000;\n    white-space: nowrap;\n    /* evita que se corte la fecha */\n  }\n\n\n  .node-label {\n    // background-color: #A9A9A9;\n    color: #1565c0;\n    font-size: 17px;\n    font-weight: 700;\n    text-transform: uppercase;\n    font-family: 'Montserrat', sans-serif;\n    border-radius: 8px;\n    display: inline-block;\n  }\n\n  .sensor-details {\n    font-size: 14px;\n    color: #333;\n    margin-bottom: 8px;\n    line-height: 1.6;\n  }\n\n  .sensor-details span {\n    display: block;\n    margin-bottom: 4px;\n  }\n\n  .sensor-details strong {\n    color: #000;\n    font-weight: 600;\n  }\n\n  .nodo-info-list {\n    list-style: none;\n    padding: 0;\n    margin-top: 15px;\n  }\n\n  .nodo-info-list li {\n    font-size: 13.5px;\n    margin-bottom: 6px;\n    color: #444;\n  }\n\n  .nodo-info-list li strong {\n    color: #000;\n    font-weight: 600;\n  }\n}\n\n\n\n\n\n\n.info-note {\n position: absolute;  /* ← Cambio clave */\n  background-color: #fff8e1;\n  border-left: 4px solid #ffc107;\n  padding: 12px 16px;\n  font-size: 14px;\n  color: #5f5f5f;\n  margin-bottom: 20px;\n  border-radius: 4px;\n\n  mat-icon {\n    vertical-align: middle;\n    margin-right: 8px;\n    color: #ffc107;\n  }\n\n  strong {\n    color: #333;\n    font-weight: 600;\n  }\n}\n/* CSS CONSOLIDADO Y CORREGIDO PARA LA NOTA DE ADVERTENCIA */\n\n.info-note.warning {\n  /* Estilos generales del contenedor de la nota */\n  background-color: #fffbe6; /* Fondo amarillo claro */\n  border-left: 5px solid #ffc107; /* Borde amarillo a la izquierda */\n  padding: 15px 20px; /* Relleno interno */\n  margin-top: 20px; /* Margen superior */\n  color: #616161; /* Color de texto oscuro */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Sombra sutil */\n  border-radius: 4px; /* Bordes redondeados */\n  font-size: 0.95em; /* Tamaño de fuente ligeramente más pequeño */\n\n  /* ----- ¡ESTO ES CRUCIAL PARA LA VISIBILIDAD DE LA X! ----- */\n  display: grid; /* Usa Grid para controlar el diseño de sus hijos (icono, contenido, botón) */\n  grid-template-columns: auto 1fr auto; /* Define 3 columnas: Icono (auto), Contenido (1fr), Botón de cierre (auto) */\n  grid-column-gap: 10px; /* Espacio entre las columnas de la cuadrícula */\n  align-items: start; /* Alinea los elementos al inicio (parte superior) de sus celdas */\n  position: relative; /* ¡MUY IMPORTANTE! Este es el contexto para 'position: absolute' del botón de cierre */\n  /* -------------------------------------------------------- */\n}\n\n/* Estilos para el icono de advertencia (el triángulo) */\n.info-note.warning .warning-icon {\n  // color: #ffeb3b; /* Color amarillo */\n  font-size: 24px; /* Tamaño del icono */\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  margin-top: -2px; /* Ajuste fino para alineación vertical */\n  grid-column: 1; /* Posiciona el icono en la primera columna de la cuadrícula */\n  grid-row: 1 / span 2; /* Hace que el icono abarque las filas del texto introductorio y la lista */\n  align-self: flex-start; /* Alinea a la parte superior de su celda */\n}\n\n/* Estilos para el contenedor del contenido del mensaje (texto intro + lista) */\n.info-note.warning .message-content {\n  grid-column: 2; /* Posiciona el contenido en la segunda columna de la cuadrícula */\n  grid-row: 1 / span 2; /* Hace que el contenido abarque las filas del texto introductorio y la lista */\n}\n\n/* Estilo para el texto introductorio (\"Se ha detectado...\") */\n.info-note.warning .message-content > ng-container {\n    display: block; /* Asegura que el texto tome su propia línea */\n    margin-bottom: 5px; /* Espacio entre el texto introductorio y la lista de errores */\n}\n\n/* Estilo para la lista de errores */\n.info-note.warning .error-list {\n  list-style: disc; /* Puntos de viñeta estándar */\n  padding-left: 20px; /* Sangría para las viñetas */\n  margin-top: 5px; /* Margen superior de la lista */\n  margin-bottom: 0;\n}\n\n/* Estilo para cada elemento de la lista */\n.info-note.warning .error-list li {\n  margin-bottom: 8px; /* Espacio entre elementos de la lista */\n  line-height: 1.4; /* Espaciado entre líneas del texto */\n}\n\n/* Estilo para la parte \"Node X:\" del mensaje */\n.info-note.warning .error-list li .node-label {\n  font-weight: bold; /* Negrita */\n  white-space: nowrap; /* Evita que \"Node X:\" se parta en varias líneas */\n}\n\n/* ----- ¡ESTOS SON LOS ESTILOS PARA EL BOTÓN DE CIERRE (LA CRUZ)! ----- */\n.info-note.warning .close-button {\n  position: absolute; /* Posicionamiento absoluto, relativo a .info-note.warning */\n  top: 5px; /* Distancia desde el borde superior */\n  right: 5px; /* Distancia desde el borde derecho */\n  color: #757575; /* Color del icono de la cruz */\n  background: none; /* Sin fondo */\n  border: none; /* Sin borde */\n  cursor: pointer; /* Cursor de puntero al pasar por encima */\n  padding: 5px; /* Área de clic alrededor del icono */\n  transition: color 0.2s ease-in-out; /* Transición suave para el efecto hover */\n  z-index: 10; /* Asegura que esté por encima de otros elementos si hay superposiciones */\n  /* Nota: Si el botón de cierre va con 'position: absolute', no necesita 'grid-column' ni 'grid-row' */\n}\n\n.info-note.warning .close-button:hover {\n  color: #424242; /* Color más oscuro al pasar el ratón */\n}\n/* ------------------------------------------------------------------ */\n\n/* REVISIÓN: Asegúrate de que tu bloque '.info-note' GENERAL (si lo tienes)\n   NO contenga 'display' ni 'position' si usas '.info-note.warning' para controlarlos.\n   Si lo tiene, el bloque '.info-note.warning' debe ir después y ser más específico.\n   Idealmente, si este es el único tipo de 'info-note', elimina el bloque '.info-note' general\n   y solo usa '.info-note.warning'.\n*/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
